import classNames from "classnames";
import { useCallback } from "react";
import { CompositeItem } from "reakit/Composite";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";

const CarouselPagingDotsItem = props => {
  const { currentSlide, index, slideCount, slides, compositeState, goToSlide } = props;

  const isActive = currentSlide === index;

  // We make the dot bigger when it is active, in addition to its opacity which is
  // changed in CSS.
  const dotRadius = isActive ? 4 : 3;

  const t = useFormatMessage();
  const ariaLabel = t(intlMessages.dotSlideAriaLabel, {
    index: index + 1,
    total: slideCount
  });

  const handleClick = useCallback(() => {
    goToSlide(index);
  }, [goToSlide, index]);

  const ariaControls = slides[index]?.id;

  const pagingDotsClassName = classNames(
    "slider-paging-dot",
    "btn-unstyled",
    "margin-xxs"
  );

  return (
    <li key={index} className={isActive ? "paging-item active" : "paging-item"}>
      <CompositeItem
        {...compositeState}
        as="button"
        type="button"
        className={pagingDotsClassName}
        onClick={handleClick}
        aria-label={ariaLabel}
        aria-current={isActive}
        aria-disabled={isActive}
        aria-controls={ariaControls}
        role="tab"
      >
        <span className="sr-only">{ariaLabel}</span>

        <svg
          className="paging-dot"
          width="10"
          height="10"
          aria-hidden="true"
          focusable="false"
        >
          {/* The white border is added through the `stroke` prop here */}
          <circle cx="5" cy="5" r={dotRadius} stroke="white" strokeWidth="1" />
        </svg>
      </CompositeItem>
    </li>
  );
};

export default CarouselPagingDotsItem;

const intlMessages = defineMessages({
  dotSlideAriaLabel: {
    id: "carousel.pagingDots.dotSlideAriaLabel",
    defaultMessage: "Aller à la diapositive {index} sur {total}"
  }
});
